import { render, staticRenderFns } from "./InteractiveRoomPayment.vue?vue&type=template&id=0b9f4204"
import script from "./InteractiveRoomPayment.vue?vue&type=script&lang=js"
export * from "./InteractiveRoomPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports